export default {
    "我的个人主页": "My homepage",
    "视频管理": "My videos",
    "历史记录": "Watch history",
    "认证管理": "Verification",
    "账户设置": "Account settings",
    "还没有关注频道": "You haven't followed any channel",
    "还没有创建频道": "You haven't created any channel",
    "账号与安全": "Account & security",
    "语言": "Language",
    "已通过": "Passed",
    "未通过": "Declined",
    "请输入视频名称搜索": "Search by video title",
    "全部视频": "All Videos",
    "视频": "Video",
    "状态": "Status",
    "创作时间": "Created",
    "上传时间": "Uploaded",
    "操作": "Actions",
    "审核中": "Under Review",
    "不公开": "Private",
    "公开": "Public",
    "去填写": "Enter",
    "编辑": "Edit",
    "更多": "More",
    "获取链接": "Fetch Link",
    "评论管理": "Comment Management",
    "下载": "Download",
    "删除": "Delete",
    "视频链接": "Video Link",
    "复制": "Copy",
    "嵌入代码": "Embed",
    "是否永久删除该作品？": "Confirm to permanently delete this video?",
    "编辑创作时间": "Edit Create Time",
    "删除作品": "Delete Video",
    "清除历史记录": "Clear History",
    "视频评论": "Video Comments",
    "未知": "Unknown",
    "筛选视频": "Filter",
    "批量删除": "Batch Delete",
    "删除评论": "Delete",
    "共x条": "{count} in total",
    "已选x条": "{count} selected",
    "是否永久删除该评论？": "Confirm to permanently delete comment?",
    "没有评论": "No comment",
    "此视频暂不公开": "The video is set as private",
    "还没有视频": "No video available",
    "去上传视频": "Upload video now",
}


// WEBPACK FOOTER //
// ./src/languages/en/people.js